import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import PlaneConfig from "@/config/PlaneConfig";
import Facade from "@/Facade";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class PlatformContainer extends BaseContainer {

  constructor(data = null) {
    super(data)
    this.init()
  }

  init(data) {
    this.arr = PlaneConfig.land
    //Signals.stopFly.add(this.stop, this)
    Signals.makeBets.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.stop, this)

    this.container1 = new PIXI.Container()
    this.addChild(this.container1)

    this.aircraftСarrier = new SpineAnimation('landStart')
    this.container1.addChild(this.aircraftСarrier)
    this.container1.visible = true

    this.smokeLiftOffAnim = new SpineAnimation('smokeLiftOffAnim')
    this.smokeLiftOffAnim.x = 540
    this.smokeLiftOffAnim.y = 270
    this.container1.addChild(this.smokeLiftOffAnim)
    this.smokeLiftOffAnim.visible = false


    this.smokeLiftOffAnim1 = new SpineAnimation('smokeLiftOffAnim')
    this.smokeLiftOffAnim1.x = 540
    this.smokeLiftOffAnim1.y = 270
    this.container1.addChild(this.smokeLiftOffAnim1)
    this.smokeLiftOffAnim1.visible = false


    this.container1.position.set(0, 0)
    this.container1.visible = false
  }

  reset() {
    const customerLogoPath = Facade.model.customerLogo

    if(!this.flag && customerLogoPath) {
      this.flag = new PIXI.Sprite(PIXI.Texture.from('flag'))
      this.flag.anchor.set(0.5)
      this.flag.position.set(800, 170)
      this.container1.addChild(this.flag)

      const logo = new PIXI.Sprite(PIXI.Texture.from(customerLogoPath))
      logo.anchor.set(0.5)
      logo.position.set(0, -120)
      this.flag.addChild(logo)
    }

    this.container1.position.set(0, 0)
    this.container1.visible = true
    this.aircraftСarrier.stop()

    this.aircraftСarrier.start(['landPrepare'], [true])
    this.stop()
  }

  start() {
    this.isStopped = false
    this.aircraftСarrier.start(['landStart'], [false])

    this.a = Math.round(Facade.model.deltaTime * 60)
    if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
      this.a = this.arr.length - 1
      const o = this.arr[this.arr.length - 1]
      this.container1.y = o.y
      this.container1.visible = true
      return
    }

    if(this.a < 5) {
      this.smokeTimer = setTimeout(() => {
        if(this.isStopped) {return}
        this.smokeLiftOffAnim.visible = true
        this.smokeLiftOffAnim1.visible = true
        this.smokeLiftOffAnim.start(['backSmokeAnim'], false)
        this.smokeLiftOffAnim1.start(['frontSmokeAnim'], false)

      }, 1000)


    }

    this.container1.visible = true

    Signals.tick.add(this.update, this)
    /*this.arr.length = 0
    TweenMax.to(this.container1, 10, {y: 1200, ease: Expo.easeInOut, onComplete: () => {
        console.log(this.arr)
      }})*/

  }

  stop() {
    this.isStopped = true
    clearTimeout(this.smokeTimer)
    this.smokeLiftOffAnim.stop()
    this.smokeLiftOffAnim1.stop()
    this.smokeLiftOffAnim.visible = false
    this.smokeLiftOffAnim1.visible = false
    Signals.tick.remove(this.update, this)
  }

  update() {
    /*const a = {
      y: Number(this.container1.y.toFixed(2))
    }
    this.arr.push(a)*/

    const o = this.arr[this.a]
    if(!o) console.log("ERROR", this.a, o)
    this.container1.y = o.y
    this.a++
    if(this.a == this.arr.length) {
      this.a = this.arr.length - 1
      this.stop()
    }

  }



}
